if (window.matchMedia('(max-width: 767px)').matches) {
const colleciton_size_wrap = new Swiper('.colleciton_size_wrap', {
    slidesPerView: 1.4,
    centeredSlides : true,
    loop: true,
    spaceBetween: 20,
    speed: 500,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
});
}

const about_slider = new Swiper('.about_slider', {
    slidesPerView: 1,
    loop: true,
    centeredslides: true,
    spaceBetween: 50,
    speed: 500,
    loopAdditionalSlides: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 1,
            spaceBetween: 60,
        }
    }

});

const florist_list = new Swiper('.florist_list', {
    centeredSlides: true,
    slidesPerView: 1.5,
    loop: true,
    spaceBetween: 20,
    speed: 500,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 2.2,
            spaceBetween: 40,
        }
    }
});